import createReceiptScanPoller from '@/core/receiptScan/receiptScanPoller'

export default {
  data: function () {
    return {
      receiptScan: {
        status: null,
        autoFill: null,
        matchCandidates: [],
        autoLinked: false,
        warnings: [],
        error: null
      },
      _receiptScanPoller: null
    }
  },

  methods: {
    startReceiptScan: function (receiptScanId, contextHint) {
      if (this._receiptScanPoller) {
        this._receiptScanPoller.cancel()
      }

      var self = this

      self.receiptScan = {
        status: createReceiptScanPoller.STATUS_UPLOADING,
        autoFill: null,
        matchCandidates: [],
        autoLinked: false,
        warnings: [],
        error: null
      }

      self._receiptScanPoller = createReceiptScanPoller({
        receiptScanId: receiptScanId,
        contextHint: contextHint || {},
        onStateChange: function (status, data) {
          self.receiptScan.status = status
          if (data && data.autoFill) {
            self.receiptScan.autoFill = data.autoFill
          }
          if (data && data.matchCandidates) {
            self.receiptScan.matchCandidates = data.matchCandidates
          }
          if (data && data.warnings) {
            self.receiptScan.warnings = data.warnings
          }
        },
        onDone: function (result) {
          self.receiptScan.status = createReceiptScanPoller.STATUS_COMPLETE
          self.receiptScan.autoLinked = result.autoLinked
          self.receiptScan.autoFill = result.autoFill
          self.receiptScan.matchCandidates = result.matchCandidates
          self.receiptScan.warnings = result.warnings
        },
        onError: function (err) {
          self.receiptScan.error = err
        }
      })

      self._receiptScanPoller.start()
    },

    cancelReceiptScan: function () {
      if (this._receiptScanPoller) {
        this._receiptScanPoller.cancel()
        this._receiptScanPoller = null
      }
    },

    applyAutoFill: function () {
      if (!this.receiptScan.autoFill) {
        return
      }
      this.$emit('receipt-scan-apply', this.receiptScan.autoFill)
    },

    dismissAutoFill: function () {
      this.receiptScan.autoFill = null
    }
  },

  beforeDestroy: function () {
    if (this._receiptScanPoller) {
      this._receiptScanPoller.cancel()
      this._receiptScanPoller = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/receiptScanMixin.js